var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 13,
  fill: "none",
  viewBox: "0 0 14 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F0B323",
  stroke: "#F0B323",
  strokeWidth: 0.6,
  d: "M6.848.729a.3.3 0 0 1 .545-.047l.02.047 1.179 3.386a.9.9 0 0 0 .692.591l.139.014 3.585.073a.3.3 0 0 1 .213.504l-.039.035-2.856 2.165a.9.9 0 0 0-.348.842l.03.137 1.038 3.431a.3.3 0 0 1-.414.359l-.044-.026-2.944-2.048a.9.9 0 0 0-.907-.07l-.12.07-2.943 2.048a.3.3 0 0 1-.47-.283l.012-.05 1.038-3.431a.9.9 0 0 0-.214-.886l-.105-.093L1.08 5.332a.3.3 0 0 1 .124-.534l.05-.005L4.84 4.72a.9.9 0 0 0 .775-.477l.056-.128z"
})));
export default SvgStar;